import { render } from "./print-debtor-receipt.vue?vue&type=template&id=5c4f5ee2"
import script from "./print-debtor-receipt.vue?vue&type=script&lang=js"
export * from "./print-debtor-receipt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__